module.exports = __webpack_public_path__ + "img/ico_perdedor_active.aa0ee1da.png";